import * as coreEntities from '_core/store/index';
import { CLIENT } from '_core/variables/constant';
import { useSelector } from 'react-redux';

export function useOrganization() {
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));
  const tenantData = useSelector((state) => coreEntities.organization.selectors.getTenant(state));
  const featureFlags = useSelector((state) => coreEntities.organization.selectors.getFeatureFlags(state));
  const canCreateGroup = useSelector((state) => coreEntities.organization.selectors.getCanCreateGroup(state));
  const canCreateCourse = useSelector((state) => coreEntities.organization.selectors.getCanCreateCourse(state));

  const canChangeAvatar = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const hasSupport = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO && client !== CLIENT.SANTILLANA_BRASIL_DEMO;
  const showAccountTab = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const showDisregardedPrograms = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const showKidsMode = client === CLIENT.SANTILLANA_PILOTO;
  const isTangerine = client === CLIENT.TANGERINE;
  const canEditProfileInfo = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const canEditCourse = client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO;

  const logoutRedirect =
    client === CLIENT.SANTILLANA_PILOTO ||
    client === CLIENT.SANTILLANA_INTEGRATIONS ||
    client === CLIENT.SANTILLANA_ALFA ||
    client === CLIENT.EDELVIVES ||
    client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const hideLibrary = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const hideTeacher = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const hideEducationLevelGroup =
    client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_INTEGRATIONS || client === CLIENT.SANTILLANA_COLOMBIA_DEMO;

  return {
    client,
    isTangerine,
    tenantConfig: {
      ...tenantData,
      ...featureFlags,
      hideTeacher: hideTeacher,
      showLogout: true,
      canChangeAvatar: canChangeAvatar,
      hasSupport: hasSupport,
      showAccountTab: showAccountTab,
      canCreateGroup: canCreateGroup,
      canCreateCourse: canCreateCourse,
      showDisregardedPrograms: showDisregardedPrograms,
      showKidsMode: showKidsMode,
      hideLibrary: hideLibrary,
      hideEducationLevelGroup: hideEducationLevelGroup,
      canEditProfileInfo: canEditProfileInfo,
      canEditCourse: canEditCourse,
      logoutRedirect: logoutRedirect,
    },
  };
}
